export default {
  selectedTPrepSubjectModuleState: state => state.selectedTPrepSubjectModule
}
